<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h2>Devices</h2>
        <hr />
      </div>
    </div>
    <div class="row" v-if="is_admin">
      <div class="col-md-12 col-lg-4">
        <router-link :to="{ name: 'DevicesAdd' }" class="btn btn-success"
          ><i class="fa fa-edit" aria-hidden="true"></i>
          Add Device
        </router-link>
        <button class="btn btn-info" @click="refresh()">
          <i class="fa fa-sync"></i> Refresh
        </button>
        <button class="btn btn-light" @click="createExportFile()">
          <i class="fa fa-file"></i> Export All
        </button>
      </div>
      <div class="col-md-1 d-none d-lg-block"></div>
      <div class="col-md-7 d-none d-lg-block">
        <div class="row">
          <label class="col-2">Type:</label>
          <div class="col-10">
            <v-select
              multiple
              v-model="device_types_selected_ids"
              :options="device_types_for_dropdown"
              :reduce="(device_type) => device_type.value"
              placeholder="Showing All"
            ></v-select>
          </div>
        </div>
        <div class="row" v-if="device_types_selected_ids.includes(2)">
          <label class="col-2">Sip Type:</label>
          <div class="col-10">
            <v-select
              multiple
              v-model="device_sip_types_selected_ids"
              :options="device_sip_types_for_dropdown"
              :reduce="(device_sip_type) => device_sip_type.value"
              placeholder="Showing All"
            ></v-select>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-12">
        <table class="table table-striped">
          <thead class="bg-hub-primary text-white">
            <tr>
              <th v-if="machine_type === 'Box'"></th>
              <th><a @click="sortBy('name')">Name</a></th>
              <th class="d-none d-md-table-cell">
                <a @click="sortBy('device_type.name')">Type</a>
              </th>
              <th class="d-none d-md-table-cell">
                Zones
              </th>
              <th class="d-none d-md-table-cell">
                <a @click="sortBy('ip')">IP</a>
              </th>
              <th><a @click="sortBy('extension')">Extension</a></th>
              <th>Manage</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="device in filtered_devices" :key="device.device_id">
              <td v-if="machine_type === 'Box' && device.online">
                <i class="far fa-check-circle online" aria-hidden="true"></i>
              </td>
              <td v-else-if="machine_type === 'Box' && !device.online">
                <i class="far fa-times-circle offline" aria-hidden="true"></i>
              </td>
              <td>
                <!-- Haven lock status -->
                <template v-if="device.device_type_id === 7">
                  <span v-html="getBatteryIcon(device.device_id)"></span>
                  <span v-if="isJammed(device.device_id)"><i style="color: red;" class="fa-solid fa-circle-exclamation fa-lg" title="The lock is jammed."></i>&nbsp;</span>
                  <span v-if="isUnlocked(device.device_id)"><i style="color: orange;" class="fa fa-unlock fa-lg" title="The lock is unlocked."></i>&nbsp;</span>
                  <span v-if="isLocked(device.device_id)"><i style="color: green;" class="fa fa-lock fa-lg" title="The lock is locked."></i>&nbsp;</span>
                  <span v-if="isUnknown(device.device_id)"><i class="fa fa-circle-question fa-lg" title="The lock status is unknown."></i>&nbsp;</span>
                </template>
                {{
                  device.name +
                  ([5,6].includes(device.device_type_id)
                    ? " (ID: " + device.device_id + ")"
                    : "")
                }}
              </td>
              <td class="d-none d-md-table-cell">
                {{ device.device_type.name }}
                <span v-if="device.device_type_id === 2"
                  >({{ device.device_sip_type.name }})</span
                >
              </td>
              <td
                class="d-none d-md-table-cell"
                v-if="
                  device.device_zones.length > 0
                "
              >
                <button
                  type="button"
                  class="btn btn-light"
                  @click="toggle_zones(device.device_id)"
                >
                  {{
                    devices_showing_zones.includes(device.device_id)
                      ? "Hide"
                      : "Show"
                  }}
                  Zones
                </button>
                <div v-if="devices_showing_zones.includes(device.device_id)">
                  <br />
                  <table class="table">
                    <tbody>
                      <tr
                        v-for="device_zone in device.device_zones"
                        :key="device_zone.zone_id"
                      >
                        <td>
                          <span v-if="device_zone.site_id === 1"
                            >[{{ device_zone.site_name }}]</span
                          >
                          {{ device_zone.name }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
              <td class="d-none d-md-table-cell" v-else>
                No zones assigned
              </td>

              <td
                class="d-none d-md-table-cell"
                v-if="![5,6,7].includes(device.device_type_id)"
              >
                <a :href="'http://' + device.ip" target="_blank">{{
                  device.ip
                }}</a>
              </td>
              <td class="d-none d-md-table-cell" v-else>N/A</td>
              <td v-if="device.device_type_id === 2">
                <span v-if="device.registered" class="registered"
                  >{{ device.extension }}
                  <i class="fa fa-phone fa-fw" aria-hidden="true"></i
                ></span>
                <span class="not-registered" v-else
                  >{{ device.extension }}
                  <i class="fa fa-phone-slash fa-fw" aria-hidden="true"></i
                ></span>
              </td>
              <td v-else>N/A</td>
              <td>
                <div class="dropdown">
                  <button
                    class="btn btn-light dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="fa fa-cogs fa-fw" aria-hidden="true"></i>
                  </button>
                  <div
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <router-link
                      :to="{
                        name: 'DevicesEdit',
                        params: { device_id: device.device_id },
                      }"
                      class="dropdown-item"
                      v-if="is_admin"
                      ><i class="fa fa-pencil-alt fa-fw" aria-hidden="true"></i
                      >&nbsp;Edit
                    </router-link>
                    <a
                      class="dropdown-item"
                      v-if="device.device_type_id === 7 && isUnlocked(device.device_id, true)"
                      href="#"
                      onclick="return false"
                      @click="lockHavenLock(device.device_id)"
                      ><i class="fa fa-lock fa-fw" aria-hidden="true"></i
                      >&nbsp;Lock</a
                    >
                    <a
                      class="dropdown-item"
                      v-if="device.device_type_id === 7 && isLocked(device.device_id, true)"
                      href="#"
                      onclick="return false"
                      @click="unlockHavenLock(device.device_id)"
                      ><i class="fa fa-unlock fa-fw" aria-hidden="true"></i
                      >&nbsp;Unlock</a
                    >
                    <a
                      class="dropdown-item"
                      href="#"
                      onclick="return false"
                      v-if="
                        device.extension !== 9000 && device.device_type_id === 2
                      "
                      @click="call(device.extension)"
                    >
                      <i class="fa fa-phone fa-fw" aria-hidden="true"></i
                      >&nbsp;Call
                    </a>
                    <a
                      class="dropdown-item"
                      href="#"
                      onclick="return false"
                      @click="deleteDevice(device)"
                      v-if="is_admin"
                      ><i class="fa fa-trash fa-fw" aria-hidden="true"></i
                      >&nbsp;Delete</a
                    >
                    <div
                      class="dropdown-divider"
                      v-if="[2, 3, 4].includes(logged_in_user.group_id) && device.device_type_id !== 7"
                    ></div>
                    <div v-if="device.device_sip_type_id === 7">
                      <a
                        class="dropdown-item"
                        :href="
                          'http://' +
                          device.ip +
                          '/status?password=' +
                          getANDCommandPassword(device)
                        "
                        target="_blank"
                        >Status</a
                      >
                      <div v-if="is_admin">
                        <a
                          class="dropdown-item"
                          :href="
                            'http://' +
                            device.ip +
                            '/reboot?password=' +
                            getANDCommandPassword(device)
                          "
                          target="_blank"
                          >Reboot</a
                        >
                        <a
                          class="dropdown-item"
                          :href="
                            'http://' +
                            device.ip +
                            '/config_all?password=' +
                            getANDCommandPassword(device)
                          "
                          target="_blank"
                          >Config All</a
                        >
                      </div>
                    </div>
                    <div v-else>
                      <div v-if="[3, 4, 5].includes(device.device_sip_type_id)">
                        <a
                          class="dropdown-item"
                          :href="'http://' + device.ip + '/#status'"
                          target="_blank"
                          >Status</a
                        >
                        <div v-if="is_admin">
                          <a
                            class="dropdown-item"
                            :href="'http://' + device.ip + '/#network'"
                            target="_blank"
                            >Network</a
                          >
                          <a
                            class="dropdown-item"
                            :href="'http://' + device.ip + '/#update'"
                            target="_blank"
                            >Update Page</a
                          >
                          <a
                            class="dropdown-item"
                            :href="'http://' + device.ip + '/update.html'"
                            target="_blank"
                            >Update State</a
                          >
                          <a
                            class="dropdown-item"
                            :href="
                              'http://' +
                              device.ip +
                              '/rc.cgi?L=uirreboot.html&c=99'
                            "
                            target="_blank"
                            >Reboot</a
                          >
                        </div>
                      </div>
                      <div v-else>
                        <a
                          class="dropdown-item"
                          v-if="device.device_type_id !== 7"
                          :href="'http://' + device.ip"
                          target="_blank"
                          >Click to Access</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-2">
        Total: {{ device_total }} <br />
        Registered: {{ device_registered_count }} / {{ device_sip_total }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import HavenLockMixin from '@/mixins/HavenLockMixin'

export default {
  components: { vSelect },
  name: 'devices',
  data: function () {
    return {
      device_types_selected_ids: [],
      device_sip_types_selected_ids: [],
      devices_showing_zones: []
    }
  },
  mixins: [HavenLockMixin],
  computed: {
    ...mapGetters({
      devices: 'allDevices',
      device_types_for_dropdown: 'allDeviceTypesForDropdown',
      device_sip_types_for_dropdown: 'allDeviceSipTypesForDropdown',
      logged_in_user: 'loggedInUser',
      machine_type: 'machineType',
      scoped_site_id: 'scopedSiteId'
    }),
    is_admin: function () {
      return [2, 3, 4].includes(this.logged_in_user.group_id)
    },
    filtered_devices: function () {
      let context = this

      return this.devices.filter(function (device) {
        if (device.site_id === context.scoped_site_id) {
          if (device.device_type_id !== 3) {
            if (context.device_types_selected_ids.length !== 0) {
              if (
                context.device_types_selected_ids.includes(
                  device.device_type_id
                )
              ) {
                if (
                  device.device_type_id === 2 &&
                  context.device_sip_types_selected_ids.length !== 0
                ) {
                  if (
                    context.device_sip_types_selected_ids.includes(
                      device.device_sip_type_id
                    )
                  ) {
                    return true
                  } else {
                    return false
                  }
                } else {
                  return true
                }
              } else {
                return false
              }
            } else {
              return true
            }
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    device_registered_count: function () {
      return this.filtered_devices.filter(
        (device) => device.registered === true
      ).length
    },
    device_sip_total: function () {
      return this.filtered_devices.filter(
        (device) => device.device_type_id === 2
      ).length
    },
    device_total: function () {
      return this.filtered_devices.length
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', false)
    this.$store.dispatch('getDevices')
    this.$store.dispatch('getDeviceTypes')
    this.$store.dispatch('getDeviceSipTypes')
  },
  methods: {
    ...mapActions(['deleteDevice']),
    createExportFile () {
      let fileExport = {
        type: 'device'
      }

      this.$store.dispatch('createExportFile', fileExport)
    },
    refresh () {
      this.$store.dispatch('getDevices')
    },
    call (extension) {
      this.$store.dispatch(
        'executeCommand',
        'start_intercom_call ' + this.scoped_site_id + ' ' + extension
      )
    },
    getANDCommandPassword (device) {
      return device.device_attributes.filter(
        (deviceAttribute) => deviceAttribute.attr_name === 'Command Password'
      )[0].attr_str
    },
    sortBy (sortBy) {
      this.$store.dispatch('sortDevices', sortBy)
    },
    toggle_zones (deviceId) {
      if (this.devices_showing_zones.includes(deviceId)) {
        this.devices_showing_zones.splice(
          this.devices_showing_zones.indexOf(deviceId),
          1
        )
      } else {
        this.devices_showing_zones.push(deviceId)
      }
    }
  }
}
</script>

<style scoped>
.online {
  color: green;
}

.offline {
  color: red;
}

.registered {
  font-weight: bold;
  color: green;
}

.not-registered {
  font-weight: bold;
  color: red;
}
</style>
